export const locales = {
  en: require('./en')
};

export default {
  typePlacehold: '请输入应用名称或关键词'
};
